export const ACTORS_EMBED_SRC = "/static/drama-actors.html?v=20261102-real-readonly-archive-del&embed=1";

import { $ } from "../lib/dom.js";

export function ensureActorsEmbed() {
  const frame = $("da-frame");
  if (!frame) return;
  const want = ACTORS_EMBED_SRC;
  if (frame.dataset.loadedSrc === want) return;
  frame.dataset.loadedSrc = want;
  frame.src = want;
}
